<template>
    <side-container
        v-bind="$attrs"
        v-if="showGoods"
        :headerTitle="mode  ===  'create'  ?  '新建商品'  :  '编辑商品'"
        :class="isChooseScan ? 'is-choose-scan' : ''"
        :width="450"
        :isShowFooterBtn="false"
        :isLoading="isAllLoading"
        @close="showGoods  =  false">
        <span v-if="mode === 'create'"
            slot="header"
            class="header-scan-btn btn fs-14 fw-600 color-green"
            @click="isChooseScan = !isChooseScan">{{ isChooseScan ? '手工录入' : '扫码录入' }}</span>
        <scan-import v-if="mode === 'create' && isChooseScan"
            v-model="scanVal"
            @confirm="nextConfirmClick" />
        <template v-else>
            <p class="mb-12 header-title">基本信息</p>
            <div  class="item  is-required">
                <span  class="des">商品名称：</span>
                <el-input ref="nameInput" @input="inputSpaceLimit(goods, 'name')" v-model="goods.name"  placeholder="请输入商品名称"  :maxlength="30"  :show-word-limit="true" @keydown.enter.native='confirmClick' />
            </div>
            <div  class="item type">
                <span  class="des">商品类目：</span>
                <el-input
                    placeholder="选择商品类目后将自动匹配商品图片"
                    readonly
                    @click.native="() => $refs.ChooseGoodsType.open()"
                    v-model="goods.type">
                    <i slot="suffix" v-if="goods.type" class="el-input__icon el-icon-error" @click.stop="() => { goods.type = ''; goods.typeId = undefined }"></i>
                    <i slot="suffix" v-else class="el-input__icon el-icon-arrow-down"></i>
                </el-input>
            </div>
            <div  class="item price"
                :class="{
                    'mb-36': !isChooseLadder,
                    'fx-v-start': isChooseLadder
                }">
                <span  class="des required">商品售价：</span>
                <template v-if="!isChooseLadder">
                    <el-input  v-model="goods.priceList[0].sale_price"
                        placeholder="请输入商品价格"
                        @input="priceLimit(get(goods, 'priceList[0]'),  'sale_price')"
                        @keydown.enter.native='confirmClick'  />
                    <div  class="tail"  @click="$refs.units.open(curUnit)">
                        <span  class="unit">元/{{  curUnit.name  }}</span>
                        <i  class="el-icon  el-icon-caret-right"  />
                    </div>
                    <button class="text-btn pl-0 pr-0"
                        @click="addLadder">+新增阶梯价</button>
                </template>
                <template v-else>
                    <el-table class="mt-0"
                        :data="goods.priceList">
                        <el-table-column
                            label="档位"
                            width="60">
                            <template v-slot="{ $index }">
                                <p class="fw-600">{{ levelsMap[$index] }}</p>
                            </template>
                        </el-table-column>
                        <el-table-column
                            prop="threshold"
                            label="购买量"
                            align="center"
                            width="120">
                            <template v-slot="{ row, $index }">
                                <p v-if="$index === 0">>=0</p>
                                <div v-else
                                    :class="{
                                        'is-error': row.isThresholdError !== -1,
                                        'is-error-zero-threshold': row.isThresholdError === 0,
                                        'is-error-prev-threshold': row.isThresholdError === 1,
                                        'is-error-next-threshold': row.isThresholdError === 2
                                    }">
                                    <el-input v-model="row.threshold"
                                        @input="handleIpt(row, 'threshold', $index)">
                                        <span slot="prefix">>=</span>
                                        <span slot="suffix">{{ curUnit.name }}</span>
                                    </el-input>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column
                            prop="sale_price"
                            label="单价"
                            align="center">
                            <template v-slot="{ row, $index }">
                                <div v-if="$index === 0"
                                    :class="{
                                        'is-error': row.isSalePriceError !== -1,
                                        'is-error-zero-saleprice': row.isSalePriceError === 0,
                                        'is-error-prev-saleprice': row.isSalePriceError === 1,
                                        'is-error-next-saleprice': row.isSalePriceError === 2
                                    }"
                                    :style="{
                                        position: 'relative'
                                    }">
                                    <el-input  v-model="row.sale_price"
                                        @input="handleIpt(row, 'sale_price', $index)"/>
                                    <div  class="tail"  @click="$refs.units.open(curUnit)">
                                        <span  class="unit">元/{{  curUnit.name  }}</span>
                                        <i  class="el-icon  el-icon-caret-right"  />
                                    </div>
                                </div>
                                <template v-else>
                                    <div class="fx-v-center">
                                        <div :class="{
                                            'is-error': row.isSalePriceError !== -1,
                                            'is-error-zero-saleprice': row.isSalePriceError === 0,
                                            'is-error-prev-saleprice': row.isSalePriceError === 1,
                                            'is-error-next-saleprice': row.isSalePriceError === 2
                                        }">
                                            <el-input v-model="row.sale_price"
                                                @input="handleIpt(row, 'sale_price', $index)">
                                                <span slot="suffix">元/{{ curUnit.name }}</span>
                                            </el-input>
                                        </div>
                                        <span class="line-delete ml-10"
                                            @click="delConfirm($index)"/>
                                    </div>
                                </template>
                            </template>
                        </el-table-column>
                        <p v-if="goods.priceList.length < 3"
                            class="align-c pt-12 pb-12"
                            slot="append">
                            <span class="href fs-12 lh-20 h-20"
                                @click="addLadder">+新增阶梯价</span>
                        </p>
                    </el-table>
                </template>
            </div>
            <div  class="item">
                <span  class="des">商品分组：</span>
                <el-cascader
                    v-if="groups.length > 0"
                    v-model="getCascaderValue"
                    :options="groups"
                    :props="{  expandTrigger:  'hover'  }"
                />
                <el-cascader v-else
                    :popper-class="'__add__group__cascader__'"
                    :options="[{ value: 'add', label: '' }]">
                    <template v-slot="{ row }">
                        <span @click="addGroup" class="href fw-400">+添加分组</span>
                    </template>
                </el-cascader>
            </div>
            <div  class="item">
                <span  class="des">商品编码：</span>
                <el-input
                    v-model="goods.code"
                    placeholder="请输入商品编码"
                    :maxlength="18"
                    :show-word-limit="true"
                    ref="codeIpt"
                    @input="codeLimit(goods,  'code')"
                    @keydown.enter.native='confirmClick'
                />
            </div>
            <div  class="item"
                :style="{
                    marginBottom: iptValidMap.isBarcodeError ? '20px' : ''
                }">
                <span  class="des">商品条码：</span>
                <base-input
                    v-model="goods.barCode"
                    placeholder="可用于收银台扫码录入商品"
                    ref="codeIpt"
                    :maxlength="14"
                    :show-word-limit="true"
                    :isShowError="iptValidMap.isBarcodeError"
                    :errorMsg="'请输入8-14位商品条码'"
                    @input="barcodeIptHandler"
                    @keydown.enter.native='confirmClick'
                />
            </div>
            <div  class="item  item-upload">
                <span  class="des">商品照片：</span>
                <qiniu-upload :imgSrc="imgSrc"
                    @clear-img="() => { imgSrc = ''; imgKey = '' }"
                    @upload-success="uploadSuccess"/>
            </div>
            <p class="mb-12 header-title super-setting">高级设置</p>
            <div class="fx-v-center fx-h-between super-setting__youhui">
                <p>
                    <span class="fs-14 color-333">参与店铺优惠</span>
                    <span class="fs-12 color-666"> (如会员折扣、整单折扣、消费送积分)</span>
                </p>
                <el-switch v-model="goods.isParticipateDiscount"
                    active-color="#009688"
                    inactive-color="#ddd"></el-switch>
            </div>
        </template>
    <!--  footer  -->
    <div  class="footer" slot="footer">
        <template v-if="mode === 'create'">
            <el-checkbox v-model="isSuccessive" class="all fw-400">连续添加商品</el-checkbox>
            <div  class ="btn-wrapper" :class="mode">
                <el-button
                    v-if="!isChooseScan"
                    class="ml-0"
                    size="medium"
                    type="primary"
                    :loading="isLoading"
                    :disabled="!canConfirm"
                    @click="confirmClick"
                >确认</el-button>
                <el-button
                    v-else
                    size="medium"
                    type="primary"
                    :loading="isNextLoading"
                    :disabled="!canNext"
                    @click="nextConfirmClick">
                    下一步
                </el-button>
            </div>
        </template>
        <template v-else>
            <span
                class="left"
                @click="handleDiffStatusClick(options.goodsInfo.status  ===  0  ?  1  :  0)"
            >{{  upGoods  ?  '上架商品'  :  '下架商品'  }}</span>
            <div  class ="btn-wrapper" :class="mode">
                <el-button
                    plain
                    size="medium"
                    type="danger" 
                    @click="handleDiffStatusClick(-1)"
                >删除</el-button>
                <el-button
                    class="ml-0"
                    size="medium"
                    type="primary"
                    :loading="isLoading"
                    :disabled="!canConfirm"
                    @click="confirmClick"
                >确认</el-button>
            </div>
        </template>
    </div>
    <!-- component -->
    <units ref="units" @selected="unitsSelect" />
    <delete-dialog ref="DeleteDialog" :loading="isdiffStatusLoading"/>
    <choose-goods-type ref="ChooseGoodsType" @choose="chooseGoodsType" :goodName="goods.name" :oldType="goods.type"></choose-goods-type>
    <goods-up-down ref="GoodsUpDown" :loading="isdiffStatusLoading"/>
    <make-group :level="1" :group="{ id: 0 }" ref="MakeGroup"/>
  </side-container>
</template>

<script lang="jsx">
import SideContainer from "@/components/layout/side-container-style2.vue"
import Units from "./modules/units.vue"
import DeleteDialog from "./modules/delete_dialog.vue"
import ChooseGoodsType from "./modules/choose_goods_types"
import GoodsUpDown from "./modules/goods_up_down.vue"
import QiniuUpload from '@/components/qiniu_upload/qiniu_upload.vue'
import MakeGroup from '../goods_list/modules/make_group.vue'
import ScanImport from './modules/scan_import.vue'
import { watch } from '@vue/composition-api'
import { openMessage, openWarning, openRenewMessage } from '@/utils/system.tsx'
import { inputLimit, inputSpaceLimit, inputValider } from "@/utils/index.ts"
import $fetch from "@/api"
import { getQiniuImgUrl } from '@/assets/ts/qiniu'
import getGroup from '@/assets/ts/group'
import get from 'lodash/get'
import clone from 'lodash/cloneDeep'
import debounce from 'lodash/debounce'
import { editionJudge } from '@/utils/editionJudge'

export default {
    data() {
        return {
            showGoods: false,
            upGoods: true,
            isLoading: false,
            lock: false,
            isAllLoading: true,
            isdiffStatusLoading: false,
            isNextLoading: false,
            isIpt: false,
            isChooseScan: false,
            isFromChooseScan: false,
            isSuccessive: localStorage.getItem('isSuccessive') ? JSON.parse(localStorage.getItem('isSuccessive')) : (localStorage.setItem('isSuccessive', JSON.stringify(false)), false),
            imgSrc: "",
            imgKey: "",
            scanVal: "",
            mode: "create",
            curUnit: {
                id: 2,
                name: "斤"
            },
            qiniu: {
                qiniuUploadUrl: "https://up.qiniup.com",
                qiniuImageURLPrefix: "https://img.senguo.cc/",
                data: {
                    key: "",
                    token: ""
                }
            },
            goods: {
                value: [],
                name: "",
                type: "",
                typeId: undefined,
                priceList: [{
                    threshold: 0,
                    sale_price: '',
                    isThresholdError: -1,
                    isSalePriceError: -1
                }],
                code: "",
                barCode: "",
                isParticipateDiscount: true
            },
            options: {
                goodsInfo: {},
                group: []
            },
            iptValidMap: {
                isBarcodeError: false
            },
            delConfirm: () => {},
            handleIpt: () => {}
        }
    },
    computed: {
        groups() {
            return getGroup(this.options.group)
        },

        canNext() {
            return this.scanVal.length > 7
        },

        canConfirm() {
            return !this.isIpt
                && this.goods.name
                && (!this.goods.barCode || this.goods.barCode.length > 7)
                && this.goods.priceList.every((priceItem, i) => priceItem.threshold !== '' && priceItem.sale_price !== '' && (i === 0 ? true : priceItem.isThresholdError === -1) && priceItem.isSalePriceError === -1)
        },

        defaultValue() {
            const groups = this.options.group
            const value = []
            if (groups[0]) {
                value.push(groups[0].value)
                if (groups[0].children && groups[0].children[0]) {
                    value.push(groups[0].children[0].value)
                }
            }
            return value
        },

        getCascaderValue: {
            get() {
                if (this.goods.value.length > 0) {
                    return this.goods.value
                } else {
                    return this.defaultValue
                }
            },

            set(newVal) {
                this.goods.value = newVal
            }
        },

        isChooseLadder() {
            return this.goods.priceList.length > 1
        },

        computedPriceList() {
            return this.goods.priceList.map(item => {
                const obj = {
                    threshold: 0,
                    sale_price: 0,
                    sale_unit: 0
                }
                Object.keys(obj).forEach(k => {
                    if (typeof item[k] === 'string' || typeof item[k] === 'number') {
                        obj[k] = +item[k]
                    }
                })
                obj.sale_unit = this.curUnit.id

                return obj
            })
        },

        get() {
            return get
        },

        levelsMap() {
            const levels = ['一级', '二级', '三级']

            return levels
        }
    },
    watch: {
        isSuccessive(newVal) {
            localStorage.setItem('isSuccessive', JSON.stringify(newVal))
        },
        isChooseScan(newVal) {
            !newVal && this.$nextTick(() => {
                this.$refs.nameInput.focus()
            })
        }
    },
    created() {
        this.debounceBarcodeErrorHandler = debounce(this.barcodeErrorHandler, 1000)
    },
    beforeDestroy() {
        this.isLoading = false
    },
    methods: {
        inputSpaceLimit,
        priceLimit: inputLimit(/^\d{1,4}(\.\d{0,2})?$/),
        codeLimit: inputLimit(/^[0-9a-zA-Z]{0,18}$/),

        barcodeIptHandler() {
            this.codeLimit(this.goods, 'barCode')
            this.debounceBarcodeErrorHandler()
        },

        barcodeErrorHandler() {
            const len = this.goods.barCode.length
            this.iptValidMap.isBarcodeError = len > 0 && len < 8
        },

        getUnitByName(name) {
            let result = {
                id: 2,
                name: '斤'
            }
            if (sessionStorage.getItem('UNITS')) {
                const filterRes = JSON.parse(sessionStorage.getItem('UNITS')).all.filter(item => item.name === name)
                if(filterRes.length > 0) {
                    result = filterRes[0]
                }
            }
            return result
        },

        async nextConfirmClick() {
            try {
                this.isNextLoading = true
                const result = await $fetch.post({
                    url: '/goods/searchgoodsbarcode',
                    params: {
                        goods_barcode: this.scanVal
                    }
                })
                console.log('根据条码搜索的商品信息', clone(result))
                this.isNextLoading = false
                if (result.code !== 1) {
                    return openMessage('error', result.msg || '搜索失败')
                }
                try {
                    const h = this.$createElement
                    const { data } = result
                    await openWarning({
                        title: '匹配商品信息',
                        type: 'primary',
                        render() {
                            return (
                                <div class="p-10 lh-20 fs-14 color-333" style="border: 1px solid #ddd">
                                    <p>商品名称：{ data.goods_name }</p>
                                    <p class="mt-6 mb-6">商品售价：￥{ data.price }元/{ data.standard }</p>
                                    <p>商品条码：{ data.barcode }</p>
                                </div>
                            )
                        }
                    })
                    this.goods.name = data.goods_name
                    this.goods.priceList[0].sale_price = data.price
                    this.goods.barCode = data.barcode
                    this.curUnit = this.getUnitByName('个')
                    this.isChooseScan = false
                    this.isFromChooseScan = true
                } catch (e) {
                    console.log('error', e)
                }
            } catch (e) {
                this.isNextLoading = false
                openMessage('error', e.message || '获取商品信息失败')
            }
        },

        createIptValider() {
            this.$nextTick(() => {
                const levels = this.goods.priceList
                const iptTypeObj = {
                    threshold: 'isThresholdError',
                    sale_price: 'isSalePriceError'
                }
                const isGTObj = {
                    threshold: true,
                    sale_price: false
                }
                const limitReg = /^\d{1,4}(\.\d{0,2})?$/
                const {
                    isIpt,
                    delConfirm,
                    handleIpt
                } = inputValider(levels, iptTypeObj, limitReg, isGTObj)
                this.delConfirm = delConfirm
                this.handleIpt = handleIpt
                watch(isIpt, (newVal) => {
                    this.isIpt = newVal
                })
            })
        },

        chooseGoodsType(type) {
            this.goods.type = type.name
            this.goods.typeId = type.id
            if (this.imgSrc.indexOf('cashier_goods_image') > -1 || !this.imgSrc) {
                this.imgSrc = type.imgSrc
                this.imgKey = type.imgKey
            }
        },

        thresholdIpt(row) {
            this.priceLimit(row, 'threshold')
        },

        salePriceIpt(row) {
            this.priceLimit(row, 'sale_price')
        },

        addLadder() {
            if (editionJudge.isBiaoZhun) {
                return openRenewMessage('标准版暂不开放此功能，如需设置阶梯价，请升级为专业版/旗舰版')
            }
            this.goods.priceList.push({
                threshold: '',
                sale_price: '',
                isThresholdError: -1,
                isSalePriceError: -1
            })
        },

        addGroup() {
            this.$refs.MakeGroup.open({
                mode: 'create',
                callback: () => {
                    this.getAllGroups()
                    this.$emit('add-group-success')
                }
            })
        },

        uploadSuccess({
            imgSrc,
            key
        }) {
            this.imgSrc = imgSrc
            this.imgKey = key
        },

        unitsSelect($event) {
            this.curUnit = $event
        },

        open(options) {
            this.initData()
            this.options = {
                goodsInfo: {},
                group: []
            }
            this.mode = options.mode || this.mode
            this.cb = options.callback || function() {}
            this.isAllLoading = true
            this.showGoods = true
            this.goods.value = [options.groupId, options.secondaryGroupId].filter(id => id != null)
            this.$nextTick(() => {
                this.$refs.nameInput.focus()
            })
            if (this.mode === "update") {
                this.goodsId = options.goodsId
                Promise.all([this.getGoodsInfo(), this.getAllGroups()])
                    .then(([_, data]) => {
                        if (this.goods.value.length === 0) {
                            this.goods.value = [this.getDefaultGroupId(data)]
                        }
                        this.createIptValider()
                        this.isAllLoading = false
                    })
            } else {
                Promise.all([this.getAllGroups(), this.getNewestGoodsUnit()])
                    .then(([data, nextData]) => {
                        if (this.goods.value.length === 1 && this.getSecondGroupId(data, options.groupId)) {
                            this.goods.value.push(this.getSecondGroupId(data, options.groupId))
                        }
                        if (this.goods.value.length === 0) {
                            this.goods.value = [this.getDefaultGroupId(data)]
                        }
                        this.createIptValider()
                        this.isAllLoading = false
                    })
            }
        },

        initData() {
            this.upGoods = true
            this.isLoading = false
            this.lock = false
            this.isAllLoading = false
            this.isdiffStatusLoading = false
            this.isNextLoading = false
            this.isIpt = false
            this.isChooseScan = false
            this.isFromChooseScan = false
            this.isSuccessive = localStorage.getItem('isSuccessive') ? JSON.parse(localStorage.getItem('isSuccessive')) : (localStorage.setItem('isSuccessive', JSON.stringify(false)), false)
            this.imgSrc = ""
            this.imgKey = ""
            this.scanVal = ""
            this.mode = "create"
            this.curUnit = this.getUnitByName('斤')
            this.qiniu = {
                qiniuUploadUrl: "https://up.qiniup.com",
                qiniuImageURLPrefix: "https://img.senguo.cc/",
                data: {
                    key: "",
                    token: ""
                }
            }
            this.goods = {
                value: [],
                name: "",
                type: "",
                typeId: undefined,
                priceList: [{
                    threshold: 0,
                    sale_price: '',
                    isThresholdError: -1,
                    isSalePriceError: -1
                }],
                code: "",
                barCode: "",
                isParticipateDiscount: true,
                member_price: "",
                pricing_methods: [],
                barcodes: []
            }
            this.iptValidMap = {
                isBarcodeError: false
            }
            this.delConfirm = () => {}
            this.handleIpt = () => {}
        },

        getSecondGroupId(groups, groupId) {
            const oGroup = groups.find(g => {
                return +g.id === groupId
            })
            if (oGroup && oGroup.secondary_group.length > 0) {
                return oGroup.secondary_group[0].id
            } else {
                return
            }
        },

        getDefaultGroupId(groups) {
            const oGroup = groups.find(g => {
                return (+g.group_type === 0)
            })
            if (oGroup == null) {
                return
            }
            return oGroup.id
        },

        getNewestGoodsUnit() {
            return $fetch.post({
                url: '/goods/getgoods',
                params: {
                    desc: true,
                    order_by: "update_time",
                    limit: 1
                }
            }).then(data => {
                const curUnit = get(data, 'goods_list[0].sale_prices[0].sale_unit')
                console.log('最近一次使用的单位', curUnit)
                curUnit && (this.curUnit = curUnit)
                return data
            }).catch(e => openMessage('error', e.message || '获取最近一次使用的单位失败'))
        },

        getGoodsInfo() {
            return $fetch
                .post({
                    url: "/goods/getgoods",
                    params: {
                        goods_id: this.goodsId
                    }
                })
                .then(
                    data => {
                        console.log("商品信息", clone(data))
                        const goodsInfo = data
                        this.options.goodsInfo = goodsInfo
                        this.curUnit = goodsInfo.pricing_methods[0].sale_prices[0].sale_unit
                        this.upGoods = goodsInfo.status === 1
                        this.goods = {
                            value: [goodsInfo.group.id, goodsInfo.secondary_group.id].filter(el => el != null),
                            name: goodsInfo.name,
                            type: goodsInfo.category.name,
                            typeId: goodsInfo.category.id,
                            priceList: goodsInfo.pricing_methods[0].sale_prices.map(item => {
                                    const obj = clone(item)
                                    obj.isThresholdError = -1
                                    obj.isSalePriceError = -1
                                    return obj
                                }),
                            code: goodsInfo.pricing_methods[0].goods_code,
                            barCode: goodsInfo.pricing_methods[0].goods_barcode,
                            isParticipateDiscount: goodsInfo.participate_discount === 1 ? true : false,
                            member_price: goodsInfo.pricing_methods[0].member_price,
                            pricing_methods: goodsInfo.pricing_methods,
                            barcodes: goodsInfo.barcodes
                        }
                        if (goodsInfo.img_url !== '') {
                            this.imgKey = goodsInfo.img_url
                            this.imgSrc = getQiniuImgUrl(goodsInfo.img_url, 800)
                        }
                    },
                    e => {
                        openMessage("error", e.message || "获取商品信息失败")
                        return Promise.reject(e)
                    }
                )
        },

        getAllGroups() {
            return $fetch
                .post({
                    url: "/goods/getgoodsgroup "
                })
                .then(data => {
                    console.log('group', clone(data))
                    this.options.group = data
                    return data
                }, e => {
                    openMessage("error", e.message || "获取商品分组失败")
                    return Promise.reject(e)
                })
        },

        handleDiffStatusClick(status) {
            if (status === -1 && !this.$store.getters['shop/canIUse'](10)) {
                return openMessage('error', '暂无删除商品权限，请联系超管开启')
            }
            if (!this.$store.getters['shop/canIUse'](11)) {
                if (status === 0) {
                    return openMessage('error', '暂无上架商品权限，请联系超管开启')
                }
                if (status === 1) {
                    return openMessage('error', '暂无下架商品权限，请联系超管开启')
                }
            }
            //   删除
            const deleteHandler = () => {
                this.showGoods = false
            }
            //   下架或上架
            const upAndDowmHandler = () => {
                this.upGoods = !this.upGoods
                this.options.goodsInfo.status = status
            }
            const obj = {
                "-1": {
                    msg: {
                        success: "删除成功",
                        error: "删除失败"
                    },
                    ref: "DeleteDialog",
                    params: {
                        goods_name: this.goods.name
                    },
                    handler: deleteHandler
                },
                "0": {
                    msg: {
                        success: "上架成功",
                        error: "上架失败"
                    },
                    ref: "GoodsUpDown",
                    params: {
                        up: this.upGoods,
                        goods_name: this.options.goodsInfo.name
                    },
                    handler: upAndDowmHandler
                },
                "1": {
                    msg: {
                        success: "下架成功",
                        error: "下架失败"
                    },
                    ref: "GoodsUpDown",
                    params: {
                        up: this.upGoods,
                        goods_name: this.options.goodsInfo.name
                    },
                    handler: upAndDowmHandler
                }
            }
            if (!obj[status]) { return }
            const objHandler = obj[status]
            this.$refs[objHandler.ref].open({
                ...objHandler.params,
                callback: (next) => {
                    this.isdiffStatusLoading = true
                    $fetch
                        .post({
                            url: "/goods/editgoodsstatus",
                            params: {
                                goods_ids: [this.options.goodsInfo.id],
                                status
                            }
                        })
                        .then(
                            data => {
                                openMessage("success", objHandler.msg.success)
                                objHandler.handler()
                                this.cb(status)
                            },
                            e => openMessage("error", e.message || objHandler.msg.error)
                        ).finally(() => {
                            this.isdiffStatusLoading = false
                            next()
                        })
                }
            })
        },

        confirmClick() {
            if (!this.canConfirm) return
            if (editionJudge.isBiaoZhun && this.computedPriceList.length > 1) {
                return openRenewMessage('标准版暂不开放此功能，如需设置阶梯价，请升级为专业版/旗舰版')
            }
            const cascaderValue = this.getCascaderValue.filter(val => (val && +val !== 0))
            const strategies = {
                create: () => {
                    this.isLoading = true
                    // 兼容多售价
                    const pricing_methods = [{
                        sale_prices: this.computedPriceList,
                        sales_unit_id: this.computedPriceList[0].sale_unit,
                        sales_unit_ratio: 1
                    }]
                    const params = {
                        sale_prices: this.computedPriceList,
                        goods_code: this.goods.code,
                        goods_barcode: this.goods.barCode,
                        name: this.goods.name,
                        category_id: this.goods.typeId,
                        img_url: this.imgKey,
                        group_id: cascaderValue[0],
                        secondary_group_id: cascaderValue[1],
                        participate_discount: this.goods.isParticipateDiscount ? 1 : 0,
                        pricing_methods
                    }
                    return $fetch
                        .post({
                            url: "/goods/addgoods",
                            params
                        })
                        .then(
                            data => {
                                openMessage("success", "添加成功")
                                this.cb()
                                if (this.isSuccessive) {
                                    this.initData()
                                    this.isChooseScan = this.isFromChooseScan
                                    this.isFromChooseScan = false
                                } else {
                                    this.showGoods = false
                                }
                            },
                            e => openMessage("error", e.message || "新增商品失败")
                        )
                        .finally(() => {
                           setTimeout(() => {
                               this.isLoading = false
                           }, 1000)
                        })
                },

                update: () => {
                    this.isLoading = true
                    // 兼容处理多售价
                    const pricing_methods = [{
                        ...this.goods.pricing_methods[0],
                        sale_prices: this.computedPriceList,
                        sales_unit_id: this.computedPriceList[0].sale_unit,
                        member_price: JSON.stringify(this.goods.pricing_methods[0].member_price ) !== '{}' ? {
                            ...this.goods.pricing_methods[0].member_price,
                            'sale_unit': this.goods.pricing_methods[0].member_price.sale_unit.id
                        } : undefined
                    }]
                    console.log(this.computedPriceList[0].sale_unit, 'this.computedPriceList.sale_unit')
                    console.log(pricing_methods, 'pricing_methods')
                    const params = {
                        goods_id: this.options.goodsInfo.id,
                        sale_prices: this.computedPriceList,
                        goods_code: this.goods.code,
                        goods_barcode: this.goods.barCode,
                        name: this.goods.name,
                        category_id: this.goods.typeId,
                        img_url: this.imgKey,
                        group_id: cascaderValue[0],
                        secondary_group_id: cascaderValue[1],
                        participate_discount: this.goods.isParticipateDiscount ? 1 : 0,
                        member_price: JSON.stringify(this.goods.member_price) !== '{}' ? {
                            ...this.goods.member_price,
                            sale_unit: this.goods.member_price.sale_unit.id
                        }: this.goods.member_price,
                        pricing_methods,
                        barcodes: this.goods.barcodes
                    }
                    return $fetch
                        .post({
                            url: "/goods/editgoods",
                            params
                        })
                        .then(
                            data => {
                                openMessage("success", "编辑成功")
                                this.cb()
                                this.showGoods = false
                            },
                            e => openMessage("error", e.message || "编辑商品失败")
                        )
                        .then(() => {
                            setTimeout(() => {
                               this.isLoading = false
                            }, 1000)
                        })
                }
            }
            if (this.isLoading) { return }
            strategies[this.mode]()
        }
    },
    components: {
        SideContainer,
        Units,
        DeleteDialog,
        ChooseGoodsType,
        GoodsUpDown,
        QiniuUpload,
        MakeGroup,
        ScanImport
    }
}
</script>

<style lang="scss">
.__add__group__cascader__ {
    .el-cascader-menu__wrap {
        height: auto;
    }

    .el-cascader-menu__list {
        padding: 0;
    }

    .el-cascader-node {
        height: 40px;
        line-height: 40px;
        padding: 0;
    }

    .el-cascader-node__prefix {
        display: none;
    }

    .href {
        display: block;
        height: 100%;
    }
}
</style>

<style lang="scss" scoped>
::v-deep.side-layout-bg {
    &.is-choose-scan main {
        padding: 20px 12px;
    }

    main {
        padding: 20px 12px 20px 20px;
        box-sizing: border-box;
    }
}

::v-deep .el-loading-mask {
  left: auto;
  width: 450px;
}

.header-scan-btn {
    padding: 4px 13px;
    border: 1px solid #009688;
    border-radius: 4px;
}

.item {
    position: relative;
	display: flex;
	align-items: center;
	margin-bottom: 12px;
	font-size: 14px;
	font-family: "PingFangSC-Regular";
	color: #333;

	&.item-upload {
	    align-items: flex-start;
	}

    &.type {
        ::v-deep .el-input {
            cursor: pointer;
            .el-input__suffix {
                font-size: 16px;
            }
        }
    }

	&.price {
		::v-deep .el-input__inner {
			padding-right: 53px;
        }

        ::v-deep .el-table {
            th {
                background-color: #fff;
                
                .cell {
                    color: #999;
                }
            }

            .el-table__body tr {
                &:first-child td {
                    &:last-child {
                        .cell {
                            width: 142px;

                            .tail {
                                font-size: 14px;
                                color: #333;

                                span {
                                    align-self: center;
                                    padding-bottom: 0;
                                    transform: translateX(4px);
                                }
                            }
                        }
                    }
                }

                &:not(:first-child) td {
                    .cell .el-input__suffix {
                        padding-right: 4px;
                    }
                }

                &:last-child td {
                    border: none !important;
                }

                td {
                    height: 60px;

                    .el-input {
                        &__inner {
                            color: #333;
                        }

                        &__prefix,
                        &__suffix {
                            color: #333;
                        }
                    }

                    &:nth-child(2) {
                        .el-input__inner {
                            padding-left: 23px;
                            padding-right: 30px;
                        }
                    }

                    &:nth-child(3) {
                        .el-input__inner {
                            padding-left: 8px;
                        }
                    }
                }
            }
        }
	}

	&.is-required {
		&::before {
		  content: "*";
		  position: absolute;
		  left: -10px;
		  top: 14px;
		  color: #e51c23;
		  font-size: 16px;
		}
	}

	.des {
		flex: none;
		width: 70px;
		height: 20px;
		line-height: 20px;
	}

	.tail {
		position: absolute;
		right: 0;
        top: 50%;
        margin-top: -20px;
		display: flex;
		justify-content: flex-end;
		align-items: flex-end;
		width: 53px;
		height: 40px;
		box-sizing: border-box;
		background: rgba(0, 150, 136, 0.1);
		font-size: 12px;
		color: #666;
		user-select: none;
        cursor: pointer;

        span {
            padding-bottom: 5px;
        }

		.el-icon-caret-right {
            padding-bottom: 5px;
            transform: translate3d(0, 3px, 0) rotateZ(45deg);
            font-size: 12px;
		}
  }

	.text-btn {
		position: absolute;
		left: 70px;
		bottom: -28px;
		font-size: 12px;
		line-height: 20px;
	}

	::v-deep > .el-cascader {
		flex: 1;
	}

	::v-deep > .el-input {
		.el-input__inner {
			color: #333;
			padding: 0 8px;

			&::placeholder {
				color: #999;
			}
		}
		.el-input__count-inner {
			font-size: 14px;
		}
	}
}

.super-setting {
    &__youhui {
        p {
            height: 20px;
            line-height: 20px;
        }
    }
}

.footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 100%;
    padding: 7px 12px;

    &.end {
        justify-content: flex-end;
    }

    .left {
        font-size: 14px;
        color: #3c90ff;
        ;
        cursor: pointer;
    }

    .btn-wrapper.update {
        ::v-deep .el-button--danger {
            border: 1px solid #ddd !important;
            border-radius: 4px 0 0 4px !important;
        }

        ::v-deep .el-button--primary {
            border-radius: 0 4px 4px 0 !important;
        }
    }
}

div.is-error {
    position: relative;
    margin: 20px 0;
    border: 1px solid #e51c23;
    border-radius: 4px;

    ::v-deep.el-input__inner {
        border: none;
    }

    &::before {
        content: '';
        position: absolute;
        left: 0;
        bottom: -20px;
        width: 120px;
        height: 20px;
        line-height: 20px;
        text-align: left;
        color: #e51c23;
        font-size: 12px;
    }

    &.is-error-zero-threshold::before {
        content: '购买量不能为0';
    }

    &.is-error-next-threshold::before {
        content: '购买量需低于下一档';
    }

    &.is-error-prev-threshold::before {
        content: '购买量需高于上一档';
    }

    &.is-error-zero-saleprice::before {
        content: '单价不能为0';
    }

    &.is-error-next-saleprice::before {
        content: '单价需高于下一档';
    }

    &.is-error-prev-saleprice::before {
        content: '单价需低于上一档';
    }
}
</style>
